import {createSlice} from '@reduxjs/toolkit';

const diagnosticsModalSlice = createSlice({
  name: 'diagnosticsModal',
  initialState: {
    vehicle: '',
    faultCode: '',
    faultDescription: '',
    severity: '',
    seen: '',
  },
  reducers: {
    setInitialValues(state, action) {
      const faultData = action.payload;
      // Table rows carry vehicleName
      state.vehicle = faultData.vehicleName;
      state.faultCode = faultData.faultCode;
      state.faultDescription = faultData.faultDescription;
      state.severity = faultData.severity;
      state.seen = faultData.seen;
    },
  },
});

export const {setInitialValues} = diagnosticsModalSlice.actions;
export default diagnosticsModalSlice.reducer;
